import { useStore, create } from "zustand";

import { AmpolService, createAmpolServiceDataSchema } from "./types";

interface AmpolServiceDataStore {
  loading: boolean;
  error: string | undefined;
  services: Map<string, AmpolService> | undefined;
  fetchServices: (url: string) => void;
}

const ampolServiceDataStore = create<AmpolServiceDataStore>()((set, get) => ({
  loading: false,
  services: undefined,
  error: undefined,
  fetchServices: async (url: string) => {
    // Services being fetched..
    if (get().loading === true) return;
    if (get().services != null) return;

    // Fetch the services
    set({ loading: true, error: undefined });
    try {
      const response = await fetch(url);
      const data = await response.json();

      const parsed = createAmpolServiceDataSchema().parse(data);

      const services = parsed.reduce((acc, service) => {
        const next = new Map(acc);
        next.set(service.$id, service);

        return next;
      }, new Map<string, AmpolService>());

      set({ services, loading: false, error: undefined });
    } catch (e) {
      set({ loading: false, error: (e as Error).message });
    }
  },
}));

function useAmpolServiceDataStore(): AmpolServiceDataStore;
function useAmpolServiceDataStore<T>(
  selector: (state: AmpolServiceDataStore) => T,
  equals?: (a: T, b: T) => boolean
): T;
function useAmpolServiceDataStore<T>(
  selector?: (state: AmpolServiceDataStore) => T,
  equals?: (a: T, b: T) => boolean
) {
  return useStore(ampolServiceDataStore, selector!, equals);
}

export default useAmpolServiceDataStore;
